import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CosignMetaBody } from "@/core/types";

import { cosignatureKeys } from "../keyFactory";
import { getAddendumCosignMeta } from "../queryFunctions/getAddendumCosignMeta";

type UseAddendumCosignMetaProps<TData = CosignMetaBody> = {
  documentId: string;
  enabled?: boolean;
  select?: (data: CosignMetaBody) => TData;
};

type AddendumCosignMetaQueryOptions = UseQueryOptions<
  CosignMetaBody,
  unknown,
  CosignMetaBody,
  ReturnType<typeof cosignatureKeys.addendumMeta>
>;

export function optionFactory(documentId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getAddendumCosignMeta(documentId),
    queryKey: cosignatureKeys.addendumMeta(documentId),
  } satisfies AddendumCosignMetaQueryOptions;
}

export function useAddendumCosignMeta<TData = CosignMetaBody>({
  documentId,
  enabled,
  select,
}: UseAddendumCosignMetaProps<TData>) {
  return useQuery({ ...optionFactory(documentId, enabled), select });
}
